var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShuttle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 88.889,
    height: 40,
    viewBox: "0 0 88.889 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_353",
    width: 88.889,
    height: 40,
    transform: "translate(102 1547)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_26",
    transform: "translate(-102 -1547)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_shuttle_transport",
    transform: "translate(102.024 1547)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1473",
    d: "M71.511,2a4.355,4.355,0,0,0-3.667-2H4.333A4.325,4.325,0,0,0,0,4.333V30.022a4.325,4.325,0,0,0,4.333,4.333H6.622a5.667,5.667,0,1,0,11.333,0h1.422a5.667,5.667,0,0,0,11.333,0H62a5.667,5.667,0,1,0,11.333,0h2.889a4.329,4.329,0,0,0,4.311-4.6A58.728,58.728,0,0,0,71.511,2.022Z",
    transform: "translate(0 0)",
    fill: "#013d53",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1474",
    d: "M5.819,15.339a4.088,4.088,0,0,1-1.289-.556l.644-1.467a3.769,3.769,0,0,0,1.089.489,3.971,3.971,0,0,0,1.222.178c.756,0,1.133-.178,1.133-.578a.465.465,0,0,0-.333-.444,7,7,0,0,0-1.044-.311,13.111,13.111,0,0,1-1.311-.356,2.305,2.305,0,0,1-.911-.622,1.72,1.72,0,0,1-.378-1.156A1.971,1.971,0,0,1,5,9.361a2.341,2.341,0,0,1,1.044-.822A4.3,4.3,0,0,1,7.752,8.25a5.517,5.517,0,0,1,1.356.156,4.331,4.331,0,0,1,1.178.444l-.6,1.467a4.1,4.1,0,0,0-1.933-.533,1.683,1.683,0,0,0-.867.178.514.514,0,0,0-.267.444.467.467,0,0,0,.311.422,5.515,5.515,0,0,0,1.022.289,11.628,11.628,0,0,1,1.311.356,2.305,2.305,0,0,1,.911.622,1.614,1.614,0,0,1,.378,1.156,1.859,1.859,0,0,1-.356,1.133,2.5,2.5,0,0,1-1.044.822,4.244,4.244,0,0,1-1.689.311,6.8,6.8,0,0,1-1.644-.2Z",
    transform: "translate(5.537 10.083)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1475",
    d: "M14.294,8.33v6.978H12.317V12.574H9.628v2.733H7.65V8.33H9.628v2.622h2.689V8.33h1.978Z",
    transform: "translate(9.35 10.181)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1476",
    d: "M12.107,14.6a3.175,3.175,0,0,1-.867-2.4V8.33h1.978v3.8q0,1.667,1.333,1.667c.889,0,1.311-.556,1.311-1.667V8.33h1.956V12.2a3.175,3.175,0,0,1-.867,2.4,3.344,3.344,0,0,1-2.422.844A3.344,3.344,0,0,1,12.107,14.6Z",
    transform: "translate(13.738 10.181)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1477",
    d: "M16.593,9.9H14.46V8.34H20.7V9.9H18.571v5.422H16.593V9.9Z",
    transform: "translate(17.673 10.193)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1478",
    d: "M19.483,9.9H17.35V8.34h6.244V9.9H21.461v5.422H19.483V9.9Z",
    transform: "translate(21.206 10.193)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1479",
    d: "M20.49,8.33h1.978v5.422H25.8v1.556H20.49Z",
    transform: "translate(25.043 10.181)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1480",
    d: "M28.83,13.784v1.533h-5.6V8.34H28.7V9.873H25.186v1.178H28.3v1.467H25.186v1.267H28.83Z",
    transform: "translate(28.392 10.193)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_354",
    width: 88.889,
    height: 40,
    transform: "translate(0 0)",
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShuttle);
export default __webpack_public_path__ + "static/media/shuttle.8c4e235de1078ecf0302be78da9094e0.svg";
export { ForwardRef as ReactComponent };